import {
  Box,
  Grid,
  makeStyles,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useCallback, useEffect, useRef, useState } from "react";

import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import CustomPagination from "../../../components/Common/CustomPagination";
import { getCurrentUserId, toastError, toastSuccess } from "../../../utils";
import * as actions from "./actions";

import _ from "lodash";
import SearchBar from "../../../common/Search";
import CustomTabs from "../../../common/Tabs";
import AddUpdateComplaints from "./AddUpdateComplaints";

const useStyles = makeStyles({
  root: {
    width: "fit-content",
  },
});

const initialSearchType = {
  type: "",
  saveLabel: "",
  name: "",
  firstLoadPort: "",
  lastDischargePort: "",
  loadQuantity: "",
  createdDate: "",
};

function Support(props) {
  const { loader = false, setLoader = () => { } } = props;
  const classes = useStyles();

  const [value, setValue] = useState(1);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [savedResults, setSavedResults] = useState([]);
  const [searchType, setSearchType] = useState({ ...initialSearchType });

  const [singleResults, setSingleResults] = useState({});

  const [myFilters, setMyFilters] = useState({
    offset: 1,
    limit: 50,
    sortBy: "createdAt",
    sortDirection: "desc",
  });
  const [hasFetched, setHasFetched] = useState(false);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState({});
  const [warningModal, setWarningModal] = useState(false);
  // const organizationId = getCurrentUserOrganizationId();
  const addDetailsModalRef = useRef();

  const [searchValue, setSearchValue] = useState("");
  const onSearchVessel = (search) => {
    getAllSavedResults(search);
  };
  const delaySearch = useCallback(
    _.debounce((data) => onSearchVessel(data), 500),
    []
  );
  const onSearchChange = (e) => {
    setSearchValue(e.target.value);
    delaySearch(e.target.value);
  };
  useEffect(() => {
    getAllSavedResults(searchValue);
  }, [myFilters.offset, myFilters.sortBy, myFilters.sortDirection]);
  const onCloseModal = () => {
    setOpen(false);
    setIsEdit(false);
    setSingleResults({});
  };
  const getAllSavedResults = async (search) => {
    setLoader(true);
    await actions
      .getComplaints({
        userId: getCurrentUserId(),
        search: search,
        offset: myFilters.offset,
        limit: myFilters.limit,
        sortBy: myFilters.sortBy,
        sortDirection: myFilters.sortDirection
      })
      .then((res) => {
        setLoader(false);
        setHasFetched(true);
        setSavedResults(res?.data?.list || []);
        setMyFilters(prev => ({
          ...prev,
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage,
        }));
      })
      .catch((err) => {
        setLoader(false);
        setHasFetched(true);
        toastError(err?.data?.message);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchType({ ...initialSearchType });
  };

  const onClickDeletAddress = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const onChangeMyPagination = (type = "") => {
    let newMyFilters = {};
    if (type === "inc") {
      newMyFilters = { ...myFilters, offset: myFilters.offset + 1 };
    } else if (type === "first") {
      newMyFilters = { ...myFilters, offset: 1 };
    } else {
      if (myFilters.offset === 1) return;
      newMyFilters = { ...myFilters, offset: myFilters.offset - 1 };
    }
    setMyFilters(newMyFilters);
  };

  const handleSortClick = (sortKey) => {
    let newSortDirection = "asc";
    if (myFilters.sortBy === sortKey) {
      if (myFilters.sortDirection === "asc") newSortDirection = "desc";
      else if (myFilters.sortDirection === "desc") {
        newSortDirection = sortKey === "createdAt" ? "asc" : "";
      }
    } else {
      newSortDirection = sortKey === "createdAt" ? "desc" : "asc";
    }

    let nextSortBy = sortKey;
    if (!newSortDirection) {
      nextSortBy = "createdAt";
      newSortDirection = "desc";
    }

    setMyFilters((prev) => ({
      ...prev,
      offset: 1,
      sortBy: nextSortBy,
      sortDirection: newSortDirection,
    }));
  };

  const onDeleteAddress = () => {
    setLoader(true);
    actions
      .deleteComplaints(deleteId)
      .then((res) => {
        toastSuccess("Result deleted successfully");
        setDeleteModal(false);
        setDeleteId("");
        getAllSavedResults();
      })
      .catch((err) => {
        toastError();
        setLoader(false);
      });
  };
  const onSubmitConfirm = () => {
    if (isEdit) {
      setWarningModal(true);
    } else {
      if (addDetailsModalRef.current && addDetailsModalRef.current.onSubmitQuery) {
        addDetailsModalRef.current.onSubmitQuery();
      }
    }
  };

  const onClickEditAddress = async (item) => {
    setLoader(true);
    await actions
      .getSingleComplaints({ complaintsId: item?._id })
      .then((res) => {
        setSingleResults(res?.data || {});
        setIsEdit(true);
        setLoader(false);
        setOpen(true);
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message);
      });
  };
  const handleDateRangeChange = async (newDateRange) => {
    const { startDate, endDate } = newDateRange;

    // Ensure dates are in ISO string format
    const formattedStartDate = startDate?.toISOString() || '';
    const formattedEndDate = endDate?.toISOString() || '';

    const { data } = await actions.getComplaints({
      userId: getCurrentUserId(),
      startDate: formattedStartDate,
      endDate: formattedEndDate
    });
    setSavedResults(data?.list);
  };
  return (
    <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      <Grid item xs={12}>
        <div className="flex items-center justify-between w-full mb-1.5">
          <Box>
            <Paper className={classes.root}>
              <CustomTabs
                tabs={[{ label: "My complaints", key: 1 }]}
                active={value}
                onChange={handleChange}
              >
                <Tab value={1} label="My complaints" />
              </CustomTabs>
            </Paper>
          </Box>
          <div className="flex items-center gap-2">
            <div className="desktop-searchbar">
              <SearchBar
                placeholder={
                  "Search with title, page,  email, mobile or status..."
                }
                onDateRangeChange={handleDateRangeChange}
                setSearchValue={onSearchChange}
                searchValue={searchValue}
              />
            </div>
            <button
              onClick={() => setOpen(true)}
              className="h-7 px-3 bg-[#313C4C] hover:bg-[#0a2a47] text-white text-[11px] font-medium rounded-none flex items-center justify-center gap-1.5 shadow-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Add Complaints
            </button>
          </div>
        </div>
        <div className="mobile-searchbar">
          <SearchBar
            isMobile
            onDateRangeChange={handleDateRangeChange}
            placeholder={"Search with title, page,  email, mobile or status..."}
            setSearchValue={onSearchChange}
            searchValue={searchValue}
          />
        </div>
      </Grid>

      <Grid item xs={12}></Grid>

      <Grid item xs={12}>
        <Box pt={0.5}>
          <TableContainer component={Paper} className="!rounded-none !shadow-sm">
            {myFilters?.totalPages > myFilters?.limit && (
              <CustomPagination
                onChangePagination={onChangeMyPagination}
                filters={myFilters}
                totalPage={myFilters?.totalPages}
              />
            )}
            <Table className="universal-table">
              <TableHead className="bg-[#313C4C]">
                <TableRow>
                  {[
                    { label: "No.", sortKey: null },
                    { label: "Title", sortKey: "title" },
                    { label: "Page", sortKey: "pageName" },
                    { label: "Email", sortKey: "emailAddress" },
                    { label: "Mobile no", sortKey: "mobileNumber" },
                    { label: "Created on", sortKey: "createdAt" },
                    { label: "Current Status", sortKey: "current_status" },
                    { label: "Action", sortKey: null },
                  ].map((header, index, array) => (
                    <TableCell
                      key={header.label}
                      className={`text-white py-1.5 px-2 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap ${index === array.length - 1 ? "border-r-0" : ""
                        } ${header.sortKey ? "cursor-pointer" : ""}`}
                      onClick={() => header.sortKey ? handleSortClick(header.sortKey) : undefined}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        {header.label}
                        {header.sortKey && (
                          <div
                            style={{
                              color: myFilters.sortBy === header.sortKey ? "#fff" : "rgba(255,255,255,0.4)",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {myFilters.sortBy === header.sortKey && myFilters.sortDirection === "desc" ? (
                              <LuArrowDown size={13} />
                            ) : myFilters.sortBy === header.sortKey && myFilters.sortDirection === "asc" ? (
                              <LuArrowUp size={13} />
                            ) : (
                              <LuArrowDownUp size={13} />
                            )}
                          </div>
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loader ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" className="!bg-white">
                      <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : Array.isArray(savedResults) && savedResults.length ? (
                  savedResults.map((item, index) => {
                    return (
                      <TableRow
                        key={index}
                        className="h-7 cursor-pointer hover:bg-gray-50"
                        onDoubleClick={() => onClickEditAddress(item)}
                      >
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{index + 1}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.title}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.pageName}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.emailAddress || ""}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.mobileNumber || ""}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">
                          {moment(item?.createdAt).format("DD/MMM/yyyy")}
                        </TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-gray-300">{item?.current_status || ""}</TableCell>
                        <TableCell className="!py-1 !px-2 border-gray-300">
                          <div className="flex items-center justify-center gap-1">
                            <button
                              onClick={() => onClickEditAddress(item)}
                              className="p-1 text-[#313C4C] hover:text-[#0a2a47] cursor-pointer"
                              title="View"
                            >
                              <VisibilityIcon style={{ fontSize: 14 }} />
                            </button>
                            <button
                              onClick={() => onClickDeletAddress(item?._id)}
                              className="p-1 text-rose-600 hover:text-rose-800 cursor-pointer"
                              title="Delete"
                            >
                              <DeleteIcon style={{ fontSize: 14 }} />
                            </button>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : hasFetched ? (
                  <TableRow>
                    <TableCell colSpan="8" align="center" className="!bg-white">
                      No complaints Found.
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
            {myFilters?.totalPages > myFilters?.limit && (
              <CustomPagination
                onChangePagination={onChangeMyPagination}
                filters={myFilters}
                totalPage={myFilters?.totalPages}
              />
            )}
          </TableContainer>
        </Box>
      </Grid>

      <CustomConfirmModal
        open={deleteModal}
        handleClose={() => setDeleteModal(false)}
        message="Are you sure you want to delete this complaint details?"
        onSubmitConfirm={onDeleteAddress}
        type="warning"
        confirmText="DELETE"
        cancelText="Cancel"
        note="This action cannot be undone."
      />

      <CustomAddModal
        open={open}
        title={isEdit ? "Update Complaints" : "Add Complaints"}
        maxWidth="md"
        saveLabel={isEdit ? "Update" : "Create"}
        handleClose={onCloseModal}
        onSubmitConfirm={onSubmitConfirm}
        isDetailView={singleResults?.current_status === "resolved" ? true : false}
      >
        <AddUpdateComplaints
          ref={addDetailsModalRef}
          setLoader={setLoader}
          onCloseModal={onCloseModal}
          getAllSavedResults={getAllSavedResults}
          singleResults={singleResults}
          isEdit={isEdit}
        />
      </CustomAddModal>

      {/* <CustomAddModal
                open={isCopyConfirm}
                handleClose={onCopyClick}
                onSubmitConfirm={onCopySaveClick}
                maxWidth="xs"
                saveLabel="Create"
                title="Copy to Org"
            >
                <ShareWithOrg
                    value={shareLabel}
                    onChange={(e) => setShareLabel(e.target.value)}
                    placeholder="Enter Voyages name*"
                />
            </CustomAddModal> */}
      <CustomConfirmModal
        open={warningModal}
        handleClose={() => setWarningModal(false)}
        message="Are you sure you want to update this complaint details?"
        onSubmitConfirm={() => {
          if (addDetailsModalRef.current.onSubmitQuery) {
            addDetailsModalRef.current.onSubmitQuery();
          }
          setWarningModal(false);
        }}
        type="warning"
        confirmText="UPDATE"
        cancelText="Cancel"
        note="This action cannot be undone."
      />
    </Grid>
  );
}

export default Support;
